module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body el-row"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.edit.title')) + "\n      ")])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.clients.edit.overview'),
      "name": "1"
    }
  }, [_c('el-row', {
    staticClass: "margin-b-10",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "full-w flex wrap"
  }, [(_vm.client.picture && Object.keys(_vm.client.picture).length) ? _c('img', {
    staticClass: "client-picture",
    attrs: {
      "src": _vm.client.picture.url,
      "alt": _vm.client.firstName
    }
  }) : _c('div', {
    staticClass: "client-picture client-avatar-initials",
    style: ({
      backgroundColor: _vm.getAvatarColor(_vm.client)
    }),
    attrs: {
      "title": _vm.client.companyName || ((_vm.client.firstName) + " " + (_vm.client.lastName))
    }
  }, [_vm._v(_vm._s(_vm.getInitials(_vm.client)))]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.client.companyName || ((_vm.client.firstName) + "\n                " + (_vm.client.lastName))) + "\n              ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v("\n                " + _vm._s(_vm.$t('static.accountInformation.organizationInformation')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.client.clientNumber) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-building-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.organizationNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.client.organizationNumber || '–') + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.email')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.client.email) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientType')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentType.name) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientGroup')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentGroup.name) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.isProducer')) + "\n                ")]), _vm._v(" "), (_vm.client.isProducer) ? _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.yes')) + "\n                ")]) : _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.no')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.systemGenerated')) + "\n                ")]), _vm._v(" "), (_vm.client.systemGenerated) ? _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.yes')) + "\n                ")]) : _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.no')) + "\n                ")])]), _vm._v(" "), (_vm.hasEHFModule) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.ehfInvoiceSupport')) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.ehfSupportStatusText) + "\n                ")])]) : _vm._e()]), _vm._v(" "), (_vm.client.contacts.length) ? _c('h4', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.accountInformation.contactInformation')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.client.contacts), function(contact) {
    return (contact.id) ? _c('fieldset', {
      key: ("contact-" + (contact.id)),
      staticClass: "margin-b-10"
    }, [_c('legend', _vm._l((contact.contact_types), function(type) {
      return _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t(("form.contactTypes.options." + (_vm.camelize(type.name))))) + "\n                  " + _vm._s(contact.contact_types.length > 1 ? '/' : '') + "\n                ")])
    }), 0), _vm._v(" "), (contact.first_name) ? _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.firstName')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(contact.first_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.last_name) ? _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.lastName')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(contact.last_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.email) ? _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.email')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(contact.email) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.phone_number) ? _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-phone",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.phoneNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(contact.phone_number) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.mobile_number) ? _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-mobile",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.mobileNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(contact.mobile_number) + "\n                ")])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.client.addresses.length) ? _c('h4', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.accountInformation.addressInformation')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.client.addresses), function(address) {
    return (address.id) ? _c('fieldset', {
      key: ("address-" + (address.id)),
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v("\n                " + _vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(address.address_type.name))))) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-address-book-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                   " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(address.street_name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-address-book-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                   " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(address.second_street_name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-address-book",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(address.postal_code) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {
      staticClass: "label label--small"
    }, [_c('i', {
      staticClass: "fa fa-address-book",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                  " + _vm._s(address.city_name) + "\n                ")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.glnOverviewShow('gln')) ? _c('fieldset', [_c('legend', [_c('span', [_vm._v("\n                  " + _vm._s('GLN Registry') + "\n                ")])]), _vm._v(" "), (_vm.glnOverviewShow('gln_number')) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  \n                  GLN number\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.gln) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.glnOverviewShow('gln_x_koord')) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  \n                    GLN X-coordinates\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.glnXKoord) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.glnOverviewShow('gln_y_koord')) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  \n                  GLN Y-coordinates\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.glnYKoord) + "\n                ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasMarketplaceModule && _vm.marketplaces.length) ? [(_vm.marketplaces.length) ? _c('h4', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.accountInformation.marketplace')) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.marketplaces), function(marketplace) {
    return _c('fieldset', {
      key: ("marketplace-" + (marketplace.id)),
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v(_vm._s(marketplace.name))]), _vm._v(" "), _c('el-button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          return _vm.inviteToMarketplace(marketplace.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.invite').toUpperCase()))])], 1)
  })] : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "full-w flex-column"
  }, [_c('div', {
    staticClass: "full-w flex justify-center wrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.index',
        query: {
          filter: ("client," + (_vm.client.id))
        }
      }
    }
  }, [_c('div', {
    staticClass: "\n                      flex-column\n                      justify-center\n                      margin-b-10 margin-r-10\n                      stats-card\n                    "
  }, [_c('span', {
    staticClass: "stats-card--number margin-b-10"
  }, [_vm._v(_vm._s(_vm.client.ordersCount))]), _vm._v(" "), _c('span', {
    staticClass: "stats-card--text"
  }, [_vm._v(_vm._s(_vm.$t('static.clients.info.orders')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'bills.index',
        query: {
          filter: ("client," + (_vm.client.id))
        }
      }
    }
  }, [_c('div', {
    staticClass: "\n                      flex-column\n                      justify-center\n                      margin-b-10 margin-r-10\n                      stats-card\n                    "
  }, [_c('span', {
    staticClass: "stats-card--number margin-b-10"
  }, [_vm._v(_vm._s(_vm.client.billsCount))]), _vm._v(" "), _c('span', {
    staticClass: "stats-card--text"
  }, [_vm._v(_vm._s(_vm.$t('static.clients.info.bills')))])])])], 1)])])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.clients.basicInformation'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.clients",
      "hasLabel": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.clients.contacts'),
      "name": "3"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 24
    }
  }, [(_vm.contactFormErrors.primary) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('form.clients.primaryContactError')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-client-contact', {
    attrs: {
      "clientId": _vm.currentClient.id
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.clients.addresses'),
      "name": "4"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 24
    }
  }, [(_vm.clientAddresses) ? _c('el-collapse', {
    model: {
      value: (_vm.clientAddressNames),
      callback: function($$v) {
        _vm.clientAddressNames = $$v
      },
      expression: "clientAddressNames"
    }
  }, _vm._l((_vm.clientAddresses), function(address, index) {
    return _c('el-collapse-item', {
      key: address.id,
      attrs: {
        "title": _vm.$t(("form.addressTypes.options." + (_vm.camelize(address.name)))),
        "name": address.name
      }
    }, [_c('v-client-address', {
      attrs: {
        "id": address.id,
        "name": address.name,
        "errors": _vm.getAddressFieldErrors(address.id),
        "data": address,
        "countries": _vm.countries.items,
        "municipalities": _vm.municipalities.items
      },
      on: {
        "update": function($event) {
          _vm.clientAddresses[index] = $event
        }
      }
    })], 1)
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.clients.licenses'),
      "name": "5"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-button', {
    staticClass: "margin-b-10 small",
    on: {
      "click": _vm.addLicense
    }
  }, [_vm._v(_vm._s(_vm.$t('static.license.add')))]), _vm._v(" "), (_vm.licenses.length) ? _c('div', {
    staticClass: "flex stretch wrap"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licenses
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationNumber",
      "label": _vm.$t('static.license.organizationNumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "licenseNumber",
      "label": _vm.$t('static.license.licenseNumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "licenseType",
      "label": _vm.$t('static.license.licenseType')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "licensePermitType",
      "label": _vm.$t('static.license.licensePermitType')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "validFrom",
      "label": _vm.$t('static.license.validFrom')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "validTo",
      "label": _vm.$t('static.license.validTo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.license.groups')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.licensePermitGroups.length > 0) ? _c('ul', {
          staticStyle: {
            "padding": "0"
          }
        }, _vm._l((scope.row.licensePermitGroups), function(group) {
          return _c('li', [_vm._v("\n                      " + _vm._s(group.licenseGroup) + "\n                    ")])
        }), 0) : _vm._e()]
      }
    }], null, false, 1675627584)
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.clients.catalogues.title'),
      "name": "6"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-button', {
    staticClass: "margin-b-10 small",
    on: {
      "click": _vm.sendCatalogue
    }
  }, [_vm._v(_vm._s(_vm.$t('static.clients.catalogues.sendCatalogue')))])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.tabIndex !== 'overview') ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'clients.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), (_vm.client.ordersCount == 0) ? _c('el-button', {
    staticClass: "outline danger",
    attrs: {
      "disabled": _vm.client.systemGenerated ? true : false,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.deleteClient').toUpperCase()) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "disabled": _vm.client.systemGenerated ? true : false,
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcaf60da","hasScoped":false}!./src/app/pages/withNavigation/clients/edit/edit.html
// module id = 3129
// module chunks = 1